export const errorMsgList = {
    "CSR-106EU": "We are unable to retrieve your application as your case has been submitted or the reference number is invalid/expired. Please refer to your email/SMS again or submit a new application.",
    "CSR-100001EU": "We are unable to retrieve your application at the moment, please try again later.",
    "CSR-107EU": "We are unable to retrieve your application as your case has been submitted or the reference number is invalid/expired. Please refer to your email/SMS again or submit a new application.",
    "dEU": "We are unable to retrieve your application as your case has been submitted or the reference number is invalid/expired. Please refer to your email/SMS again or submit a new application.",
    "EMPTYEU": "Please enter Reference number.",
    "TRY-AGAIN-LATEREU": "We are unable to retrieve your application at the moment, please try again later.",
    "CSR-106TC": "由於您的申請已提交或參考編號無效/過期，我們無法檢索您的申請。請再次查看您的電子郵件/短訊或提交新的申請。",
    "CSR-100001TC": "我們目前無法檢索您的申請，請稍後再試。",
    "CSR-107TC": "由於您的申請已提交或參考編號無效/過期，我們無法檢索您的申請。請再次查看您的電子郵件/短訊或提交新的申請。",
    "dTC": "由於您的申請已提交或參考編號無效/過期，我們無法檢索您的申請。請再次查看您的電子郵件/短訊或提交新的申請。",
    "EMPTYTC": "請輸入參考編號",
    "TRY-AGAIN-LATEREU": "我們目前無法檢索您的申請，請稍後再試。",
    "CSR-106SC": "由于您的申请已提交或参考编号无效/过期，我们无法检索您的申请。请再次查看您的电子邮件/短讯或提交新的申请。",
    "CSR-100001SC": "我们目前无法检索您的申请，请稍后再试。",
    "CSR-107SC": "由于您的申请已提交或参考编号无效/过期，我们无法检索您的申请。请再次查看您的电子邮件/短讯或提交新的申请。",
    "dSC": "由于您的申请已提交或参考编号无效/过期，我们无法检索您的申请。请再次查看您的电子邮件/短讯或提交新的申请。",
    "EMPTYSC": "请输入参考编号",
    "TRY-AGAIN-LATERSC": "我们目前无法检索您的申请，请稍后再试。",
}